import Vue from 'vue';

Vue.component('audit-trail-index', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './audit-trail-index.vue'),
);
